import type { SimpleSessionViewV2 } from '@heidi/session/contracts';
import { parseTimeStamp } from '@heidi/utils';
import { differenceInMilliseconds, isAfter, isBefore } from 'date-fns';

export const filterAndSortSessions = (
  isUpcoming: boolean,
  sessions: SimpleSessionViewV2[]
) => {
  return sessions
    ?.filter((session) => {
      const isSessionFromEhrAppt = Boolean(session?.ehr_appt_id);

      const localTime = parseTimeStamp(
        session.created_time_local || session.created_at,
        !isSessionFromEhrAppt
      );
      const now = new Date();
      return isUpcoming ? isAfter(localTime, now) : isBefore(localTime, now);
    })
    ?.sort((a, b) => {
      const timeA = parseTimeStamp(
        a.created_time_local || a.created_at,
        !Boolean(a?.ehr_appt_id)
      );
      const timeB = parseTimeStamp(
        b.created_time_local || b.created_at,
        !Boolean(b?.ehr_appt_id)
      );
      return isUpcoming
        ? differenceInMilliseconds(timeA, timeB)
        : differenceInMilliseconds(timeB, timeA);
    });
};
